import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-answer-ask-for-help.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessAnswerAskForHelp';

class AgentBookingMailInprocessAnswerAskForHelpCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessAnswerAskForHelp implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessAnswerAskForHelpCtrl];
}

export default MODULE_NAME;
